
import React , {useEffect, useState } from 'react'; 
import app from "./app" 
import {GridWrap, ListWrap, Elements, AlertModal, WebPreview} from "./helpers" 
import ReactDOM from 'react-dom';

export const WebsiteOne = function(props) {  
    const {data, index, widgetType, mode, device} = props;
    let listitem = "" 
    if(data.elements.websites){ 
         if(data.elements.websites.items){   
            listitem = data.elements.websites.items.map(function(v, i){ 
                return <GridWrap className="h-100" data={v} key={'key-' + v.viewId + i} id="websites" mode={mode} device={device}>
                    <Elements row={v.banner} id={"banner"} device={device} mode={mode}/>  
                    <Elements row={v.heading} id={"heading"} device={device} mode={mode}/> 
                    <Elements row={v.summary} id={"summary"} device={device} mode={mode}/>  
                    <div style={device === "desktop"?{margin:app.elementPadding(v.properties.marginWeb)}:{margin:app.elementPadding(v.properties.margin)}}>
                        <Elements row={v.primaryButton} id={"primaryButton"} device={device} mode={mode}/>
                    </div> 
                </GridWrap>
            }) 
        }
        
        listitem = <ListWrap data={data.elements.websites} className={'g-4'} mode={mode} device={device} index={index}>
            {listitem}
        </ListWrap>
    }

return  <div className="container-fluid p-0 position-relative"> 
        <div className="row">
            <div className="col-12">
                <Elements row={data.elements.heading} id={"heading"} device={device} mode={mode}/>
                <Elements row={data.elements.summary} id={"summary"} device={device} mode={mode}/>  
            </div>
        </div>
        {listitem} 
    </div>
}

export const WebsiteTwo = function(props) { 
    const {data, index, widgetType, mode, device} = props;
    // console.log("data", data)
    let listitem = "" 
    if(data.elements.websites){ 
         if(data.elements.websites.items){   
            listitem = data.elements.websites.items.map(function(v, i){    
                return <GridWrap className="h-100" data={v} key={'key-' + v.viewId + i} id="websites" mode={mode} device={device}>
                    {/* <Elements row={v.banner} id={"banner"} device={device}/>   */}
                    <Elements row={v.icon} id={"icon"} device={device} mode={mode}/> 
                    <Elements row={v.heading} id={"heading"} device={device} mode={mode}/> 
                    <Elements row={v.summary} id={"summary"} device={device} mode={mode}/>  
                    <div style={device === "desktop"?{margin:app.elementPadding(v.properties.marginWeb)}:{margin:app.elementPadding(v.properties.margin)}}>
                        <Elements row={v.primaryButton} id={"primaryButton"} device={device} mode={mode}/>
                    </div>
                    
                </GridWrap> 
            }) 
        } 
        listitem = <ListWrap data={data.elements.websites} className={'align-items-stretch g-4'} mode={mode} device={device} index={index}>
            {listitem}
        </ListWrap>
    }

return  <div className="container-fluid p-0 position-relative"> 
        <div className="row">
            <div className="col-12">
                <Elements row={data.elements.heading} id={"heading"} device={device} mode={mode}/>
                <Elements row={data.elements.summary} id={"summary"} device={device} mode={mode}/>  
            </div>
        </div>
        {listitem} 
    </div>
}

export const WebAppConverter = function({data, index, widgetType, mode, device}) {
    const [url, setUrl] = useState('');
    const [alertShown, setAlertShown] = useState(false);
     

   useEffect(() => {  
    if(mode === "live" && data.elements){
        if(device === "desktop"){ 
            if(data.elements.primaryButton.properties.showWeb){ 
                if(data.elements.primaryButton.properties.autoLoadLink){ 
                    if(document.querySelector(".webAppConverterBtn")){
                        document.querySelector(".webAppConverterBtn").click()
                    } 
                } 
            } 
        }else{
            if(data.elements.primaryButton.properties.show){
                if(data.elements.primaryButton.properties.autoLoadLink){
                    if(document.querySelector(".webAppConverterBtn")){
                        document.querySelector(".webAppConverterBtn").click()
                    } 
                } 
            } 
        } 
   }
}); 
 

    
   let mobileHeaderInfo = [ {  "iconCss": " icon-spin3", "class": "float-start"}, {  "iconCss": "icon-left-open", "class": "mx-1"}, {  "iconCss": "icon-right-open", "class": "mx-1"}]
   let list = ""
   mobileHeaderInfo = mobileHeaderInfo.map(function(v, i){ 
    if(i === 0){
        list = <a className={`fa ${v.iconCss} ${v.class}`}  key={'key-'+i} style={{color:app.getColor(data.elements.primaryButton.properties.iconActiveColor), background:app.getColor(data.elements.primaryButton.properties.iconActiveBackground)}}></a>;
        return false;
    }
    return <a className={`fa ${v.iconCss} ${v.class}`}  key={'key-'+i} style={{color:app.getColor(data.elements.primaryButton.properties.iconColor), background:app.getColor(data.elements.primaryButton.properties.iconBackground)}}></a>
   }) 
   let header = <div className={`social headerShow row`} style={{margin:"-10px -26px 6px"}}>
       <div className='col py-2' style={{background:app.elementBackground(data.elements.primaryButton.properties.headerBgColor, data.elements.primaryButton.properties.headerBgType)}}>{list}<div className='float-end d-flex' style={{direction:"ltr"}}>{mobileHeaderInfo}</div></div>
   </div>
    if(!data.elements.primaryButton.properties.showHeader){
       header = ""
   }

   if(device === "desktop" || data.elements.primaryButton.properties.target || !data.elements.primaryButton.properties.autoLoadLink){ 
       header = ""
   }

   let properties = data.elements.primaryButton.properties;
   let websiteLink = properties.link;
//    let websiteLink = 'https://www.yahoo.com/';
  
   if(websiteLink && mode === "preview") {
        const host = new URL(websiteLink);
        const name = `websites/${host.host.replaceAll(".", "-")}-${device}.png`;
        let src = `https://mediadirhub.com/${name}`
        return <img src={src} className="w-100 mw-100" />
   } 

   return <div className="container-fluid p-0 position-relative">
       {header}
       {/* <Elements row={data.elements.mobileHeader} id={"mobileHeader"} device={device}/> */}
       <div className="row"> 
           <div className="col-12"> 
               <Elements row={data.elements.heading} id={"heading"} device={device} mode={mode}/>
               <Elements row={data.elements.summary} id={"summary"} device={device} mode={mode}/>
               <div style={device === "desktop"?{margin:app.elementPadding(data.properties.marginWeb)}:{margin:app.elementPadding(data.properties.margin)}}> 
                   <Elements row={data.elements.primaryButton} id={"primaryButton"} device={device} classType="webAppConverterBtn" mode={mode}/>
               </div>
           </div>
       </div>
   </div>
}


const WebsiteView = function({websiteLink}) {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState(null);

    useEffect(() => {  
        // console.log("Ravi Kumar", websiteLink);
        
        if(window.getScreenshot && !app.checkLocalHost()) {
            // setLoading(true);
            // window.getScreenshot(websiteLink).then(function(data){
            //     console.log(data);
            //     setData(data);
            //     setLoading(false);
            // });
        }
       
    }, [websiteLink]);

    
   
    const src = `https://media.mediadirhub.com/images/website-to-app.png`;
    let qrSrc = "https://d2wuvg8krwnvon.cloudfront.net/appqrcode/mobile_012b149c4914.png";
    if(!app.isServer()) {
        if(localStorage.getItem("aiAppId")) {
            // Read the host from config, never hardcode it: bucket72 differs
            // per branch, and a staging app id only resolves in the staging
            // bucket. This line held main's host verbatim, so staging asked
            // production for a QR that was never there.
            qrSrc = `${app.config().bucket72}/appqrcode/mobile_${localStorage.getItem("aiAppId")}.png`
        }
    }
    //let image =  <img className='w-100 mw-100' src={src} />
    let image = <div className='qrcode-view w-100 p-0'>
        <img className='w-100 mw-100' src={src} alt='' />
        <img className='qrcode' src={qrSrc} alt='' />
    </div>

    if(loading) {
        image = <div className="w-100 d-flex align-items-center justify-content-center" style={{minHeight:"500px"}}>
            <div className="preloader-2" style={{width:"100px", height:"100px", borderRadius:"100%"}}></div>
        </div>
    }
    return <a className='position-relative elements button w-100 mw-100 text-dark' src={src} id={"primaryButton"}>
       {image}
    </a>
}

export const WebAppConverterTwo = function({data, index, widgetType, mode, device}) {
    const [url, setUrl] = useState('');
    const [alertShown, setAlertShown] = useState(false);
    //  console.log("data", data)

   useEffect(() => {  
    // console.log("data.elements.primaryButton", data.elements.primaryButton)
    if(mode === "live" && data.elements){
        
        if(device === "desktop"){ 
            if(data.elements.primaryButton.properties.showWeb){ 
                if(data.elements.primaryButton.properties.autoLoadLink){ 
                    if(document.querySelector(".webAppConverterBtnTwo")){
                        document.querySelector(".webAppConverterBtnTwo").click()
                    } 
                } 
            } 
        }else{
            if(data.elements.primaryButton.properties.show){
                if(data.elements.primaryButton.properties.autoLoadLink){
                    if(document.querySelector(".webAppConverterBtnTwo")){
                        document.querySelector(".webAppConverterBtnTwo").click()
                    } 
                } 
            } 
        } 
   }   
}); 
 

    
   let mobileHeaderInfo = [ {  "iconCss": " icon-spin3", "class": "float-start"}, {  "iconCss": "icon-left-open", "class": "mx-1"}, {  "iconCss": "icon-right-open", "class": "mx-1"}]
   let list = ""
   mobileHeaderInfo = mobileHeaderInfo.map(function(v, i){ 
    if(i === 0){
        list = <a className={`fa ${v.iconCss} ${v.class}`}  key={'key-'+i} style={{color:app.getColor(data.elements.primaryButton.properties.iconActiveColor), background:app.getColor(data.elements.primaryButton.properties.iconActiveBackground)}}></a>;
        return false;
    }
    return <a className={`fa ${v.iconCss} ${v.class}`}  key={'key-'+i} style={{color:app.getColor(data.elements.primaryButton.properties.iconColor), background:app.getColor(data.elements.primaryButton.properties.iconBackground)}}></a>
   }) 
   let header = <div className={`social headerShow row`} style={{margin:"0px -26px 6px"}}>
       <div className='col py-2' style={{background:app.elementBackground(data.elements.primaryButton.properties.headerBgColor, data.elements.primaryButton.properties.headerBgType)}}>{list}<div className='float-end d-flex' style={{direction:"ltr"}}>{mobileHeaderInfo}</div></div>
   </div>
    if(!data.elements.primaryButton.properties.showHeader){
       header = ""
   }

   if(device === "desktop" || data.elements.primaryButton.properties.target || !data.elements.primaryButton.properties.autoLoadLink){ 
       header = ""
   }
 

   let properties = data.elements.primaryButton.properties;
   let websiteLink = properties.link; 
   if(websiteLink && (mode == "preview" || mode == "edit") && device === "mobile") {
       
    const host = new URL(websiteLink);
    const name = `websites/${host.host.replaceAll(".", "-")}-mobile.png`;
    let src = `https://mediadirhub.com/${name}`
    // let src = 'https://www.lipsum.com/images/banners/black_120x240.gif'
    // return <img src={src} className="w-100 mw-100" />
    //return <WebsiteView websiteLink={websiteLink} />
    return <div>
            {header}
            <WebsiteView websiteLink={websiteLink} />
        </div>
   } 

   return <div className="container-fluid p-0 position-relative">
       {header}
       {/* <Elements row={data.elements.mobileHeader} id={"mobileHeader"} device={device}/> */}
       <div className="row"> 
           <div className="col-12"> 
               <Elements row={data.elements.heading} id={"heading"} device={device} mode={mode}/>
               <Elements row={data.elements.summary} id={"summary"} device={device} mode={mode}/>
               <div style={device === "desktop"?{margin:app.elementPadding(data.properties.marginWeb)}:{margin:app.elementPadding(data.properties.margin)}}> 
                <Elements row={data.elements.primaryButton} id={"primaryButton"} device={device} classType="webAppConverterBtnTwo" mode={mode}/>
            </div>
           </div>
       </div>
   </div>
}